import { baseThemeValues } from 'constants/common';

const circleBaseProps = {
  borderRadius: '50%',
  borderWidth: '1px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 600,
};

export const revertStepBarTheme = {
  circle: {
    active: {
      ...circleBaseProps,
      bg: 'palette.warning.50:0.15',
      borderColor: 'palette.warning.50',
      text: 'palette.warning.50',
    },
    passed: {
      ...circleBaseProps,
      bg: 'palette.success.50:0.15',
      borderColor: 'palette.success.50',
      text: 'palette.success.50',
    },
    upcoming: {
      ...circleBaseProps,
      bg: 'palette.tertiary.40:0.15',
      borderColor: 'palette.tertiary.40',
      text: 'palette.tertiary.40',
    },
  },
  connector: {
    passed: 'palette.tertiary.40',
    upcoming: 'palette.tertiary.30',
  },
  label: {
    active: 'palette.tertiary.95',
    passed: 'palette.tertiary.95',
    upcoming: 'palette.tertiary.40',
  },
};
